import 'core-js/stable';
import 'regenerator-runtime/runtime';

// fetch() polyfill for making API calls.
require('whatwg-fetch');
